// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-smart-component {
  --height-smart-component-compact: 158px;
  --padding-component: 10px;
  --size-icon-main: 50px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: var(--padding-component);
  background-color: white;
  min-height: var(--height-smart-component-compact);
}
.container-smart-component.supervision-view {
  --size-icon-main: 70px;
  --height-smart-component-compact: 70px;
  --padding-component: 0;
  height: -moz-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 200px;
  box-shadow: none;
  background-color: transparent;
}
.container-smart-component ion-button[disabled] {
  opacity: 1;
}
@media (max-width: 768px) {
  .container-smart-component:not(.supervision-view) {
    --height-smart-component-compact: 70px;
  }
  .container-smart-component:not(.supervision-view) ion-button {
    width: 50px;
    height: 50px;
  }
  .container-smart-component:not(.supervision-view) ion-button ion-icon {
    font-size: 36px;
  }
}
.container-smart-component .expanded {
  height: 100%;
}

.icon-and-text {
  display: flex;
  align-items: center;
  gap: 10px;
}
.icon-and-text.right-orientation {
  flex-direction: row-reverse;
  text-align: right;
}
.icon-and-text.up-orientation {
  gap: 5px;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}
.icon-and-text.up-orientation .title {
  line-height: 2.1;
}
.icon-and-text.down-orientation {
  flex-direction: column-reverse;
  text-align: center;
  justify-content: center;
}
.icon-and-text {
  height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2);
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.supervision-view .title {
  font-size: 15px;
}

.container-spinner {
  height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2);
  width: 100%;
}

ion-button {
  flex-shrink: 0;
  --border-radius: 50%;
  --padding-start: 0;
  --padding-end: 0;
  width: 70px;
  height: 70px;
  --background: var(--ion-color-light);
  --box-shadow: 0;
  --ripple-color: var(--ion-color-primary-shade);
  color: var(--ion-color-primary-contrast);
  --transition: transform .2s ease-out;
}
ion-button ion-icon {
  font-size: 50px;
  color: var(--ion-color-medium);
}
ion-button.ion-activated {
  scale: 1.1;
}

:host-context(.vimar) ion-button {
  --background: var(--ion-color-light);
  --border-width: 3px;
  --border-style: solid;
  --border-color: transparent;
}
:host-context(.vimar) ion-button ion-icon {
  color: var(--label-color);
}
:host-context(.vimar) ion-button.running {
  --background: var(--ion-color-light);
  --border-color: var(--ion-color-primary);
}
:host-context(.vimar) ion-button.running ion-icon {
  color: var(--label-color);
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/widget-scenario/widget-scenario.component.scss","webpack://./src/components/shared-components/styles/mixins.scss"],"names":[],"mappings":"AAEA;ECDI,uCAAA;EACA,yBAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,uBAAA;EACA,iDAAA;ADCJ;ACCI;EACI,sBAAA;EACA,sCAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;ADCR;ACEI;EACI,UAAA;ADAR;AAlBI;EADA;IAEE,sCAAA;EAqBJ;EAnBI;IACE,WAAA;IACA,YAAA;EAqBN;EAnBM;IACE,eAAA;EAqBR;AACF;AAhBE;EACE,YAAA;AAkBJ;;AAdA;ECII,aAAA;EACA,mBAAA;EACA,SAAA;ADcJ;ACZI;EACI,2BAAA;EACA,iBAAA;ADcR;ACXI;EACI,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;ADaR;ACXQ;EACI,gBAAA;ADaZ;ACTI;EACI,8BAAA;EACA,kBAAA;EACA,uBAAA;ADWR;AAtCA;EAEE,kFAAA;AAuCF;;AApCA;ECsCI,eAAA;EACA,gBAAA;ADEJ;;AArCA;EACE,eAAA;AAwCF;;AArCA;ECmBI,kFAAA;EACA,WAAA;ADsBJ;;AAtCA;EACE,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,8CAAA;EACA,wCAAA;EACA,oCAAA;AAyCF;AAvCE;EACE,eAAA;EACA,8BAAA;AAyCJ;AAtCE;EACE,UAAA;AAwCJ;;AAlCA;EACE,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;AAqCF;AAnCE;EACE,yBAAA;AAqCJ;AAhCE;EACE,oCAAA;EACA,wCAAA;AAkCJ;AAhCI;EACE,yBAAA;AAkCN","sourcesContent":["@use \"../../styles/mixins\" as *;\n\n.container-smart-component {\n  @include external-apparance;\n\n    &:not(.supervision-view) {\n    @media (max-width: 768px) {\n      --height-smart-component-compact: 70px;\n\n      ion-button {\n        width: 50px;\n        height: 50px;\n\n        ion-icon {\n          font-size: 36px;\n        }\n      }\n    }\n  }\n\n  .expanded {\n    height: 100%;\n  }\n}\n\n.icon-and-text {\n  @include icon-and-text;\n  height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n}\n\n.title {\n  @include title-main;\n}\n\n.supervision-view .title {\n  font-size: 15px;\n}\n\n.container-spinner {\n  @include container-spinenr;\n}\n\nion-button {\n  flex-shrink: 0;\n  --border-radius: 50%;\n  --padding-start: 0;\n  --padding-end: 0;\n  width: 70px;\n  height: 70px;\n  --background: var(--ion-color-light);\n  --box-shadow: 0;\n  --ripple-color: var(--ion-color-primary-shade);\n  color: var(--ion-color-primary-contrast);\n  --transition: transform .2s ease-out;\n\n  ion-icon {\n    font-size: 50px;\n    color: var(--ion-color-medium);\n  }\n\n  &.ion-activated {\n    scale: 1.1;\n  }\n}\n\n// Vimar theme: mirror the scenario.component look (bordered circle whose border\n// turns primary when running) instead of the default filled-primary background.\n:host-context(.vimar) ion-button {\n  --background: var(--ion-color-light);\n  --border-width: 3px;\n  --border-style: solid;\n  --border-color: transparent;\n\n  ion-icon {\n    color: var(--label-color);\n  }\n\n  // Like scenario.component, the running state only turns the border primary\n  // (the icon itself stays unchanged).\n  &.running {\n    --background: var(--ion-color-light);\n    --border-color: var(--ion-color-primary);\n\n    ion-icon {\n      color: var(--label-color);\n    }\n  }\n}","@mixin external-apparance {\n    --height-smart-component-compact: 158px;\n    --padding-component: 10px;\n    --size-icon-main: 50px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 15px;\n    display: flex;\n    flex-direction: column;\n    padding: var(--padding-component);\n    background-color: white;\n    min-height: var(--height-smart-component-compact);\n\n    &.supervision-view {\n        --size-icon-main: 70px;\n        --height-smart-component-compact: 70px;\n        --padding-component: 0;\n        height: fit-content;\n        width: fit-content;\n        max-width: 200px;\n        box-shadow: none;\n        background-color: transparent;\n    }\n\n    ion-button[disabled] {\n        opacity: 1;\n    }\n}\n\n@mixin icon-and-text {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &.right-orientation {\n        flex-direction: row-reverse;\n        text-align: right;\n    }\n\n    &.up-orientation {\n        gap: 5px;\n        flex-direction: column;\n        text-align: center;\n        justify-content: center;\n\n        .title {\n            line-height: 2.1;\n        }\n    }\n\n    &.down-orientation {\n        flex-direction: column-reverse;\n        text-align: center;\n        justify-content: center;\n    }\n}\n\n@mixin container-spinenr {\n    height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n    width: 100%;\n}\n\n@mixin icon-main {\n    width: var(--size-icon-main);\n    height: var(--size-icon-main);\n    flex-shrink: 0;\n}\n\n@mixin title-main {\n    font-size: 18px;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
